import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "../lib/api";

const KEY = "highkey_age_verified";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setOpen(true);
  }, []);
  const confirm = () => {
    localStorage.setItem(KEY, "yes");
    setOpen(false);
  };
  const deny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black"
          data-testid="age-gate-overlay"
        >
          <div className="absolute inset-0 bg-gradient-to-b from-purple-900/30 via-black to-black" />
          <div className="absolute inset-0 opacity-30 pointer-events-none"
               style={{ backgroundImage: "radial-gradient(circle at 50% 30%, rgba(147,51,234,0.5), transparent 60%)" }} />
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
            className="relative z-10 max-w-xl mx-auto text-center px-6"
          >
            <img src={LOGO_URL} alt="High Key" className="w-56 md:w-64 mx-auto mb-8 drop-shadow-[0_0_40px_rgba(147,51,234,0.7)]" />
            <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-[0.9] mb-6 mt-2">
              Are you <span className="text-[var(--hk-purple-text)]">twenty</span>
              <br />
              <span className="italic text-[var(--hk-orange)]">one</span>?
            </h1>
            <p className="text-gray-400 text-sm md:text-base mb-10 max-w-md mx-auto">
              You must be of legal age in your state to enter High Key. By continuing you confirm
              you&apos;re 21+ and agree to our terms.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                data-testid="age-gate-confirm"
                onClick={confirm}
                className="bg-[var(--hk-orange)] text-black font-display font-bold uppercase tracking-wider px-8 py-4 rounded-sm hover:bg-[var(--hk-orange-hover)] transition-colors glow-orange"
              >
                I&apos;m 21 or older
              </button>
              <button
                data-testid="age-gate-deny"
                onClick={deny}
                className="border border-white/20 text-white/70 font-display font-bold uppercase tracking-wider px-8 py-4 rounded-sm hover:border-white/40 hover:text-white transition-colors"
              >
                Exit
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
